import React from "react";

const CommonHeading = ({ heading, className }) => {
  return (
    <>
      <div className="px-5">
        <h3 className={`text-uppercase ${className}`}>{heading}</h3>
      </div>
    </>
  );
};

export default CommonHeading;
